import React from 'react'
import Search from '../../assets/icons/search'
import './searchbar.css'

export default function Searchbar({iconColor, placeholder}) {
    

    return (
       <div className='searchbar'>
           <Search fill={iconColor}  />
           {/* <img src='/assets/icons/search.svg' className='searchbar__icon' /> */}
           <input  placeholder={placeholder}  />
       </div>

    )
}
